import { TracingBase } from "./tracingBase";
import { ITranslatable } from "./interfaces";

/** Traceability Model with Language Code */
export class TransTracingBase extends TracingBase implements ITranslatable {
    /** Language Code   Trans PK */
    public languageCE: string;
}

